import React, { FC, useState } from "react";
import { Box, InputAdornment, TextField } from "@mui/material";
import { floatNumberInputProps } from "../../../constants";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  input: {
    "& input": {
      fontWeight: 500,
    },
    "& input[type=number]": {
      "-moz-appearance": "textfield",
    },
    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
  },
  gramContainer: {
    position: "relative",
  },
  gram: {
    position: "absolute",
    zIndex: 2,
    top: "52%",
    transform: "translateY(-52%)",
    fontSize: 16,
  },
}));

export interface AdvancedNutritionInputProps {
  value: number;
  onChange: (value: number) => void;
  dirty: boolean;
  displayError?: boolean;
}

const AdvancedNutritionInput: FC<AdvancedNutritionInputProps> = ({
  value,
  onChange,
  dirty,
  displayError = false,
}) => {
  const s = useStyles();
  const inputRef = React.useRef<HTMLInputElement>(null);
  const [focus, setFocus] = useState(false);

  return (
    <Box className={s.gramContainer}>
      <TextField
        type="number"
        inputRef={inputRef}
        variant="outlined"
        fullWidth
        autoComplete="off"
        size="small"
        value={value}
        onChange={(e) => {
          onChange(parseFloat(e.target.value));
        }}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        className={s.input}
        error={(!value || value <= 0) && dirty && displayError}
        slotProps={{
          input: {
            inputProps: floatNumberInputProps,
            endAdornment: <InputAdornment position="end">g</InputAdornment>,
          },
        }}
      />
    </Box>
  );
};

export default AdvancedNutritionInput;
